import {
    Component,
    Input,
    OnInit,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    AfterContentInit,
    ElementRef,
} from '@angular/core';

/* eslint-disable @angular-eslint/component-selector */

/**
 * Icon Button component.
 * Sizes and styles controlled by BEM modifiers.
 *
 * icon?: icon name as per ihd-icon ex. 'chat', 'notifications', 'print', etc.
 *
 * @export
 * @class IconButtonComponent
 * @implements {OnInit}
 */
@Component({
    selector: '[ihdIconButton]',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-icon-btn',
        role: 'button',
        '[attr.type]': 'type',
    },
})
export class IconButtonComponent implements AfterContentInit {
    public iconClasses: string;

    @Input() icon: string = null;
    @Input('type') type: string = 'button';
    @Input('class')
    set classAttr(value) {
        this.renderStyles();
    }

    private readonly versionTwoIconButtonClass: string = 'c-icon-btn--v2';
    private readonly versionTwoIconClass: string = 'c-icon--v2';

    private iconMappings: {} = {
        'c-icon-btn--xxs': 'c-icon--xxs',
        'c-icon-btn--xs': 'c-icon--xs',
        'c-icon-btn--sm': 'c-icon--sm',
        'c-icon-btn--md': 'c-icon--md',
        'c-icon-btn--lg': 'c-icon--lg',
        'c-icon-btn--slim': 'c-icon--xxs',
    };

    constructor(private element: ElementRef) {}

    ngAfterContentInit() {
        this.renderStyles();
    }

    renderStyles() {
        this.iconClasses = '';
        const classList: any = this.element.nativeElement.classList;
        const classV2: string = classList.contains(
            this.versionTwoIconButtonClass
        )
            ? this.versionTwoIconClass + ' '
            : '';

        Object.keys(this.iconMappings).forEach((iconClass) => {
            if (classList.contains(iconClass)) {
                this.iconClasses +=
                    this.iconMappings[iconClass] + ' ' + classV2;
            }
        });
    }
}
